/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { SizeMe } from "react-sizeme";
import QuestionSlider from './components/QuestionSlider';
import MetodologyComponent from './components/Metodology';
import EmbedSize from './components/EmbedSize';
const App = () => {
  const [modal, setModal] = useState({ show: false });

  return (
    <SizeMe monitorHeight>
      {({ size }) => (
        <div className="container">
          <EmbedSize size={size} adjustment={{ widht: 25, height: 25 }} />
          <header>
            <div className="mainBanner">
              <a href="https://www.ey.com/es_cr" target="_blank" style={{ cursor: 'pointer' }} rel="noreferrer">
                <img src="https://www.nacion.com/gnfactory/especiales/2021/calculadora-renta-global-dual/images/TAX_nacion-02.jpg" alt="Banner Patrocinador" />
              </a>
            </div>
            <div className="LNlogotype">
              <object data="https://www.nacion.com/gnfactory/especiales/2021/calculadora-renta-global-dual/images/lanacion_gey.svg" aria-label=""></object>
              <h3>PRESENTADO POR:</h3>
              <a href="https://www.ey.com/es_cr" target="_blank" style={{ cursor: 'pointer' }} rel="noreferrer">
                <img src="https://www.nacion.com/gnfactory/especiales/2021/calculadora-renta-global-dual/images/ey_ad.png" max-width="145px" style={{ marginBottom: '5px' }} alt="Logo Patrocinador" />
              </a>
              <h4>CALCULADORA DE <strong>RENTA GLOBAL DUAL</strong></h4>
              <div className="metodologia">
                <p>
                  <a onClick={() => setModal({ show: true })}>Metodología</a>
                </p>
              </div>
            </div>
          </header>
          <MetodologyComponent show={modal.show} closeFnc={() => setModal({ show: false })} />
          <QuestionSlider />
        </div>
      )}
    </SizeMe>
  );
}

export default App;
